<!-- 确定上报科室 -->
<template>
  <div class='conFirmReportDept'>
    <v-header :headTitle='headTitle' :isBack='true' :pageName="pageName"></v-header>
    <div class="container">
      <div class="introduce df-center" v-if="$route.query.batch == 2021">
        本次活动要求监测的{{deptTreesData.length}}个标准科室类别如下，请根据本院科室设置的实际情况选择上报科室类别
      </div>
      <div class="introduce df-center" v-if="($route.query.batch == 2023 || $route.query.batch == 2025)">
        以下为本次活动要求调查的{{deptTreesData.length}}个标准科室，请根据本院实际情况选择上报科室（注：标准科室1-6必选一个），然后将选择的上报科室与本院的实际病区单元相匹配。
      </div>
      <div class="content">
        <div class="item" v-for='(item,index) in deptTreesData' :key='index' >
          <div class="item-title df-between" :style="{'border-bottom':item.isSelect?'1px solid #eee':'none'}" >
            <h3>标准科室{{index+1}}-{{item.deptStandardName}}</h3>
            <van-checkbox v-model="item.isSelect" :disabled='reportStatus=="1"' @click='changeSelect(item)'></van-checkbox>
          </div>
          <div class="item-content-box" v-if='item.isSelect' >
            <div class='item-content df-between' style='border-bottom:1px solid #eee'>
              <div class="item-left df-center">
                <span>与本院{{item.deptStandardName}}{{index<4?'相关病区':''}}匹配</span>
              </div>
              <div class="item-right df-center" @click='handleClickItem(index,"dept")'>
                <span class='blue' :style="{'color':item.wardList&&item.wardList.length>0?'#26b4ff':'#999'}" >{{item.wardList&&item.wardList.length>0?'已匹配'+item.wardList.length+
                  '个':"最多关联"+ relevanceNumber +"个单元"}}</span>
                <img src="../../assets/images/arrow-right.png" alt="" >
              </div>
            </div>
            <!-- <div class='item-content df-between'>
              <div class="item-left df-center">
                <span class='tips-text'>上月{{index==4?item.deptStandardName+'日门诊量':index==5?'血液透析人数':item.deptStandardName+'实际开放床位数'}}</span>
                <img class='tips-icon' v-if='index<4' @click='handleShowExplain' src="../../assets/images/wenhao.png" alt="">
              </div>
              <div class="item-right" @click='handleClickItem(index,"bed",item)'>
                <input  type="tel" pattern="[0-9]*" maxlength="6" :disabled='reportStatus=="1"' v-model='item.openBeds' oninput="this.value=(this.value.replace(/[^0-9]+/,'')).slice(0,11);" placeholder="请输入" name="" id="">
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="submit-btn df-center" @click='handleConfirm' v-if='reportStatus=="0"'> 提交 </div>
      <yd-popup v-model="isShowDeptSelect" position="right" width="100%" >
        <cascad-menu :currentIndex='currentIndex' v-on:sendDeptData='sendDeptData' :relevanceNumber='relevanceNumber' :yetSelectWards='yetSelectWards' :totalYetSelectWards='totalYetSelectWards'></cascad-menu>
      </yd-popup>
      <van-popup v-model="isShowBedSelect" round position="bottom" >
        <van-picker title="标题" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="onCancel" />
      </van-popup>
      <van-popup v-model="isShowPopup" style='border-radius:10px;'>
        <div class="dalog-box">
          <div class="dalog-content">
            <div class="dalog-title">名词解释</div>
            <p>上月实际开放床位数:</p>
            <div class='text'>实际开放床位数是指实际可以收治的住院病人的床位（包括临时床位），而编制床位数是行政部门允许的床位数，并且按照这个数据给医院相应人员编制。（上月：不限定具体某月）</div>
          </div>
          <div class="line"></div>
          <div class="dalog-btn-box df-between">
            <div class="btn df-center" @click='handleBtnRight'>知道了</div>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="isShowTips" style='border-radius:10px;'>
        <div class="dalog-box">
          <div class="dalog-content">
            <div class="dalog-title">温馨提示</div>
            <div class='text'>{{toastMsg}}</div>
          </div>
          <div class="line"></div>
          <div class="dalog-btn-box df-between">
            <div class="btn df-center" @click='isShowTips=false'>知道了</div>
          </div>
        </div>
      </van-popup>
    </div>

  </div>
</template>

<script>
  import header from '../../components/header/header'
  import CascadMenu from '../cascadMenu/cascad-menu.vue'
  import {mapState} from 'vuex'
  export default {
    data() {
      return {
        toastMsg:'',
        reportStatus:'',
        relevanceNumber:0,
        pageName: '',
        headTitle:'确定上报科室',
        isShowPopup:false,
        isShowTips:false,
        yetSelectWards:[], // 存储单前院区已选单元
        totalYetSelectWards:[], // 存储所有已选择的单元
        currentIndex:'', // 当前项
        isShowDeptSelect: false,
        isShowBedSelect:false,
        deptTreesData:[],
        columns: [ ],
      }
    },
    components: {
      'cascad-menu': CascadMenu,
      'v-header': header,
    },
    computed: {
      ...mapState({
        _userInfo: (state) => state.InvestorInfo,
      })
    },
    created() {
      this.reportStatus = localStorage.getItem('reportStatus')
      this.initData()
    },
    methods: {
      handleBedsPreview(){


      },
      onConfirm() {
      },
      onCancel() {
        this.isShowBedSelect = false
      },
      initData(){
        let params = {
          userId: this._userInfo.data.userId,
          comId: this._userInfo.data.comId,
          data: {
            comId: this._userInfo.data.comId,
            taskId:localStorage.getItem('taskId')
          }
        };
        this.$http.queryReportingDept(params).then((res) => {
          if (res.code === 0) {
            this.deptTreesData = res.data
            this.relevanceNumber = parseInt(res.data[0].wardMaxNumber)||10 //最多能关联的单元数量
            this.deptTreesData.forEach((v,i)=>{
              if(!v.wardList){
                this.$set(v,'wardList',[])
              }else{
                v.wardList = v.wardList.split(',')
                v.wardList.forEach((v1,i1)=>{
                  this.totalYetSelectWards.push({id:v1,index:i+1})
                })
              }
              if(v.wardList&&v.wardList.length>0){
                this.$set(v,'isSelect',true)
              }else{
                this.$set(v,'isSelect',false)
              }
            })
            console.log(this.deptTreesData,'this.deptTreesData');
            console.log(this.totalYetSelectWards,'totalYetSelectWards');
          } else {
            this.$toast(res.msg);
          }
        });
      },
      initBedData(id){
        let params = {
          data: {
            deptStandardIdLong: id,
          }
        };
        this.$http.queryReportingDeptOpenBeds(params).then((res) => {
          if (res.code === 0) {
            this.columns = res.data
          } else {
            this.$toast(res.msg);
          }
        });
      },
      changeSelect(val){
      },
      // 显示床位名词解释
      handleShowExplain(){
        this.isShowPopup = true
      },
      handleClickItem(index,temp){
        this.currentIndex = index
        if(temp == 'dept'){
          this.yetSelectWards = this.deptTreesData[index].wardList
          this.isShowDeptSelect = true
        }else{
          // this.initBedData(item.deptStandardId)
          // this.isShowBedSelect = true
        }
      },
      // 获取子组件带过来的单元id
      sendDeptData(val){
        this.deptTreesData[this.currentIndex].wardList = val
        this.isShowDeptSelect = false
      },
      // 知道了
      handleBtnRight(){
        this.isShowPopup = false
      },
      handleConfirm() {
        let flag = false
        let flag2 = false
        let swsReportingDeptMaps = JSON.parse(JSON.stringify(this.deptTreesData)) 
        for (let i = 0; i < swsReportingDeptMaps.length; i++) {
          if(swsReportingDeptMaps[i].isSelect&&(swsReportingDeptMaps[i].wardList==''||!swsReportingDeptMaps[i].wardList)){
            this.$toast('请选择与本院'+swsReportingDeptMaps[i].deptStandardName+(i<4?'相关病区匹配单元':'匹配单元'));
            return
          }
          // if(swsReportingDeptMaps[i].isSelect&&!swsReportingDeptMaps[i].openBeds){
          //   this.$toast(i<4?'请填写上月'+swsReportingDeptMaps[i].deptStandardName+'实际开放床位数':i==4?'请填写上月儿科门急诊日门诊量':'请填写上月血液透析人数');
          //   return
          // }
          if(Array.isArray(swsReportingDeptMaps[i].wardList)){
            if(swsReportingDeptMaps[i].isSelect){
              swsReportingDeptMaps[i].wardList = swsReportingDeptMaps[i].wardList.join()
            }else{
              swsReportingDeptMaps[i].wardList = ''
              // swsReportingDeptMaps[i].openBeds = null
            }
          }
          // if(swsReportingDeptMaps[i].wardList.length>0&&swsReportingDeptMaps[i].openBeds){ //至少选择一个上报科室，并且至少匹配了一个单元，并且已选择时机开放床位数
          if(this.$route.query.batch == 2021 ? swsReportingDeptMaps[i].wardList.length>0 : swsReportingDeptMaps[i].wardList.length>0 && swsReportingDeptMaps[i].deptStandardId != 7 ){
            flag = true
          }
          if((this.$route.query.batch == 2023 || this.$route.query.batch == 2025) && swsReportingDeptMaps[i].wardList.length>0 && swsReportingDeptMaps[i].deptStandardId == 7){
            flag2 = true
          }
        };
        console.log(this.deptTreesData,'deptTreesData');
        console.log(swsReportingDeptMaps,'swsReportingDeptMaps');
        if(flag){
          let params = {
            comId: this._userInfo.data.comId,
            data: {
              swsReportingDeptMaps: swsReportingDeptMaps,
              comId: this._userInfo.data.comId,
              userId: this._userInfo.data.userId,
              taskId:localStorage.getItem('taskId')
            }
          };
          this.$http.updateReportingDept(params).then((res) => {
            if (res.code === 0) {
              this.$toast(res.msg);
              this.$router.go(-1)
              // this.$router.push({
              //   path: "/monitorRptIndexParent",
              //   query: {
              //      comeFrom:this.$route.query.comeFrom
              //   }
              // });
            } else if(res.code === 200562){ // 完成步骤三在修改标准科室需要提示
               this.isShowTips = true
               this.toastMsg = res.msg
            } else {
              this.$toast(res.msg);
            }
          });
        }else{
          if(flag2){
            this.$toast('至少需要选择标准科室1、2、3、4、5、6中的一个')
            return
          }
          this.$toast('请先完善科室信息')
        }

      },
    },
  }
</script>
<style lang='scss'>
.item-title{
  .van-checkbox {
    flex: 1;
    padding: 10px 0px;
    display: flex;
    justify-content: flex-end;
    .van-checkbox__icon {
      font-size: 18px;
    }
  }
}
</style>
<style lang='scss' scoped>
  .conFirmReportDept {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow-x: hidden;
    .container {
       padding-bottom: 80px;
       background-color: #f2f2f2;
       height: 100vh;
       overflow: scroll;
      .introduce {
        padding: 6px 12px;
        // height: 64px;
        background: #f7f8fa;
        font-size: 14px;
        color: #666666;
      }
      .item {
        margin-bottom: 5px;
        .item-title {
          padding: 0px 12px;
          height: 50px;
          background-color: #fff;
          h3 {
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            color: #323233;
            font-size: 16px;
          }
        }
        .item-content-box {
          .item-content {
            padding: 0px 5px 0px 10px;
            height: 50px;
            background: #f5f9ff;
            span {
              color: #666666;
              font-size: 14px;
            }
            .item-left {
              justify-content: flex-start;
              .tips-icon {
                margin-left: 5px;
                width: 15px;
                height: 15px;
              }
            }
            .item-right {
              .blue {
                font-size: 13px;
              }
              img {
                margin-left: 5px;
                width: 15px;
                height: 16px;
              }
              input{
                width: 120px;
                height: 50px;
                padding-right: 10px;
                text-align: right;
                background: #f5f9ff;
                font-size: 14px;
              }
            }
          }
        }
      }
      .submit-btn {
        position: fixed;
        bottom: 0;
        // margin: 30px auto 34px;
        width: 100%;
        height: 50px;
        background: #1c91ff;
        // border-radius: 5px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        font-size: 18px;
        color: #fff;
      }
      .dalog-box {
        position: relative;
        width: 310px;
        background-color: #fff;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        border-radius: 10px;
        overflow: hidden;
        .dalog-content {
          padding: 24px;
          border-bottom: 1px solid #eee;
          .dalog-title {
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            color: #333333;
            margin-bottom: 10px;
            text-align: center;
          }
          p {
            font-size: 15px;
            color: #666;
          }
          .text{
            margin-top: 10px;
            font-size: 14px;
          }
        }
        .dalog-btn-box {
          color: #26b4ff;
          .btn {
            flex: 1;
            padding: 12px 0px;
          }
        }
      }
    }
  }
</style>